import React, { useEffect, useState } from "react";
import "./CollectionsPickerModal.css";
import { globals } from "../globals";

export default function CollectionsPickerModal({ onSelect, onCancel }) {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch(globals.homepageUrl + "/php/get-collections.php")
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setCollections(data.collections || []);
        } else {
          setError("Errore nel recupero delle collections.");
        }
      })
      .catch(() => setError("Errore di rete o server."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="collections-picker-backdrop">
      <div className="collections-picker-content">
        <h3>Seleziona una collection</h3>

        {loading && <p>Caricamento...</p>}
        {error && <p className="error">{error}</p>}
        {!loading && !error && collections.length === 0 && (
          <p>Nessuna collection disponibile.</p>
        )}

        <div className="collections-picker-grid">
          {collections.map(collection => (
            <div
              key={collection.id}
              className="collections-picker-item"
              onClick={() => onSelect(collection.id)}
            >
              {collection.featured_image ? (
                <img
                  src={`${globals.homepageUrl}/${collection.featured_image.replace(/^\/+/, "")}`}
                  alt={collection.label}
                  className="collections-picker-thumb"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    e.currentTarget.nextSibling.style.display = "block";
                  }}
                />
              ) : null}
              <div
                className="collections-picker-thumb collections-picker-placeholder"
                style={{ display: collection.featured_image ? "none" : "block" }}
              />
              <div>{collection.label || `ID ${collection.id}`}</div>
            </div>
          ))}
        </div>

        <button className="collections-picker-button" onClick={onCancel}>Annulla</button>
      </div>
    </div>
  );
}